<template>
<v-card flat >
  <v-card-title class='subheading pa-0' >
    <v-btn :loading='requests.get.loading' icon @click='window=0;get()' ><v-icon >home</v-icon></v-btn>
    <v-divider vertical class='mr-3' ></v-divider>
    {{value.first_name}} {{value.last_name}} <v-chip outline small label class='ml-2' >{{value.id}}</v-chip>
    <v-spacer></v-spacer>
    <v-btn small flat text :disabled='window===0' @click='window=0' >Programs</v-btn>
    <v-btn small outline outlined color='primary' :disabled='window===1' @click='window=1' >Assign a new program</v-btn>
    <v-btn icon small text flat
      v-if='physitrackClientId && clientLink'
      :href='clientLink' target='_blank' color='primary' >
      <v-icon>open_in_new</v-icon>
    </v-btn>
  </v-card-title>
  <v-divider></v-divider>
  <!-- <pre>{{physitrackIntegration}}</pre> -->
  <!-- <pre>{{value}}</pre> -->
  <v-window v-model="window" vertical touchless >
    <v-window-item >
      <v-layout>
        <v-flex xs6 sm5 md4>
          <v-list dense one-line>
            <v-list-tile >
              <v-list-tile-content>
                <v-list-tile-title class='subheading' >Programs</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn @click='window=1' outline outlined small >New<v-icon small>add</v-icon></v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <v-list dense>
            <program-list
              v-if='hasActivePrograms'
              @selected='setActiveProgram'
              :programs="currentlyActivePrograms" title='Active program'  >
            </program-list>
            <v-alert outline
              v-if="!hasActivePrograms && !requests.get.loading"
              :value='true' type='info' >
                No currently active program
                <v-btn @click='window=1' flat text >Assign a program</v-btn>
            </v-alert>
            <!-- <program-list
              v-if='futurePrograms && futurePrograms.length > 0'
              @selected='setActiveProgram'
              :programs="futurePrograms" title='Upcoming' >
            </program-list> -->
            <program-list
              v-if='previousPrograms && previousPrograms.length > 0'
              @selected='setActiveProgram'
              :programs="previousPrograms" title='Previous' >
            </program-list>
          </v-list>
        </v-flex>
        <v-divider vertical ></v-divider>
        <v-flex xs6 sm7 md8>
          <program v-if='selectedProgram && selectedProgram.id'
            v-model='selectedProgram'
            :dateOfBirth='yearOfBirth'
            :physitrack-client-id='physitrackClientId' >
          </program>
        </v-flex>
      </v-layout>
    </v-window-item>
    <v-window-item >
      <assign-program
        v-if='physitrackClientId && relationshipId'
        v-model='physitrackClient'
        @assigned='programAssigned'
        @close='window=0'
        :physitrack-client-id='physitrackClientId'
        :relationship-id='relationshipId'
        :has-active-program='hasActivePrograms'
        :touch='assignTouch' >
      </assign-program>
    </v-window-item>
  </v-window>
</v-card>
</template>
<script>
import {DateTime} from 'luxon'
import AssignProgram from './AssignProgram.vue'
import ProgramList from './ProgramList.vue'
import Program from './Program.vue'

export default {
  name: 'Programs',
  components: { AssignProgram, ProgramList, Program },
  props: {
    value: { type: Object, required: true },
    physitrackClientId: { required: true },
    relationshipId: { required: true }
  },
  data () {
    return {
      window: 0,
      search: '',
      assignTouch: 0,
      selectedProgram: {},
      requests: {
        get: {
          resource: 'ag.integrations',
          extra: 'physitrack/programs',
          result: {}
        }
      },
      physitrackClient: {}
    }
  },
  watch: {
    physitrackClientId: {
      immediate: true,
      handler () {
        this.get()
      }
    },
    value () {
      if (this.value) {
        this.physitrackClient = this.value
      }
    },
    window () {
      if (this.window === 0) {
        this.get()
      }
    }
  },
  computed: {
    programs () {
      return this.getObjectPath(this.requests, 'get.result.programs', [])
    },
    yearOfBirth () {
      return this.getObjectPath(this.value, 'year_of_birth')
    },
    physitrackIntegration () {
      return this.$store.getters.getIntegration('Physitrack')
    },
    physitrackBaseUrl () {
      return this.getObjectPath(this.requests.get, 'result.base')
    },
    clientLink () {
      return `${this.physitrackBaseUrl}/clients/${this.physitrackClientId}/`
    },
    hasActivePrograms () {
      if (this.currentlyActivePrograms && this.currentlyActivePrograms.length > 0) {
        return true
      }
      return false
    },
    currentlyActivePrograms () {
      return this.programs.filter((program) => {
        let now = DateTime.local()
        // let startDate = DateTime.fromISO(program.start_date)
        let endDate = DateTime.fromISO(program.end_date)
        return endDate > now
        // return (startDate <= now && now <= endDate)
      })
    },
    previousPrograms () {
      return this.programs.filter((program) => {
        let now = DateTime.local()
        let endDate = DateTime.fromISO(program.end_date)
        return now >= endDate
      })
    }
  },
  methods: {
    programAssigned (program) {
      this.window = 0
      this.get()
    },
    get () {
      if (this.physitrackClientId) {
        this.requests.get.params = {client_id: this.physitrackClientId}
        this.$request('get', this.requests.get)
      }
    },
    setActiveProgram (program) {
      this.selectedProgram = program
    }
  }
}
</script>



// WEBPACK FOOTER //
// Programs.vue?32917502